module.exports = "./img/8f5e6931b0ec073f40072c7d320d6398.jpg";